(function($) {

    $(function () {

        //   mobile menu
        var mobileMenuHeight = $(".mobile-menu__nav .menu").outerHeight();
        $(".mobile-menu .menu .menu-item-has-children > .sub-menu").prepend(
            '<li class="back-btn"><button>Back <span class="toggle"></span></button></li>'
        );

        // click
        $(".mobile-menu .menu .menu-item-has-children  > a .toggle").on(
            "click",
            function (e) {
                e.preventDefault();
                $(this).parent().next().addClass("active");
                var target = $(this).parent().next().outerHeight();
                target = target + 1;
                $(".mobile-menu .wrapper").css("height", target + "px");
                $(".mobile-menu .wrapper").addClass("active");
            }
        );
        // close
        $(".back-btn").on("click", function (e) {
            e.preventDefault();
            $(this).parent().removeClass("active");
        });

        $(".mobile-menu .menu > li > .sub-menu > li > .sub-menu .back-btn").on(
            "click",
            function (e) {
                e.preventDefault();
                var target = $(this).parent().parent().parent().outerHeight();
                target = target + 1;
                $(".mobile-menu .wrapper").css("height", target + "px");
            }
        );

        $(".mobile-menu .menu > li > .sub-menu > .back-btn").on(
            "click",
            function (e) {
                e.preventDefault();
                $(".mobile-menu .wrapper").css("height", "auto");
                $(".mobile-menu .wrapper").removeClass("active");
            }
        );

        $("header.masthead .menu-toggle").click(function (e) {
            e.preventDefault();
            $(".masthead").addClass("menu-active");
            $(".mobile-menu").addClass("active");
        });

        $(".mobile-menu .close").on("click", function(e) {
            e.preventDefault();
            $(".masthead").removeClass("menu-active");
            $(".mobile-menu").removeClass("active");
        })

    });

})(window.jQuery)